export const isNotEmptyString = (item: string | undefined | null): item is string =>
  !!item && item !== ""
